import type { OnboardingStep } from '@agentic-flow-studio/shared/components/onboarding/OnboardingChecklist';

export function onboardingSteps(orgId: string, workspaceId: string): OnboardingStep[] {
  const settings = `/org/${orgId}/workspace/${workspaceId}/settings`;

  return [
    {
      id: 'workspace-created',
      title: 'Sign in and select your workspace',
      description: 'Your shared home is ready.',
      isComplete: () => true,
    },
    {
      id: 'name-workspace',
      title: 'Name your workspace',
      description: 'Make the space recognizably yours.',
      isComplete: (state) => !state.isAutoNamed,
      isVisible: (state) => state.isAdmin,
      action: { kind: 'rename', label: 'Name workspace' },
    },
    {
      id: 'attach-context',
      title: 'Attach context to a page',
      description: 'Open the Skill Viper extension on any page and save your first anchor.',
      isComplete: (state) => state.hasAnchor,
    },
    {
      id: 'create-task-or-note',
      title: 'Create a task or note',
      description: 'Capture something worth remembering on that page.',
      isComplete: (state) => state.hasTaskOrNote,
    },
    {
      id: 'invite-teammate',
      title: 'Invite a teammate',
      description: 'Bring in the first person you will collaborate with.',
      isComplete: (state) => state.hasTeammate,
      isVisible: (state) => state.isAdmin,
      action: { kind: 'link', label: 'Invite teammate', to: `${settings}/members` },
    },
    {
      id: 'start-trial',
      title: 'Assign a 3rd seat and start the trial',
      description:
        'Growing past two seats unlocks a 14-day trial of the Founding Team plan, no card required.',
      isComplete: (state) => state.productTier !== null && state.productTier !== 'free',
      isVisible: (state) => state.isAdmin,
      action: { kind: 'link', label: 'Manage seats', to: `${settings}/members` },
    },
  ];
}
